import { MenuTypeV2, WithPaginationMetaResponse } from "..";

/**
 * chat_roomsとtel_fortune_chat_roomsのstatus
 */
export const purchaseHistoryStatus = {
  /** chat_rooms.status: 0 */
  unpaid: "unpaid",
  /**
   * chat_room.status: 10
   * tel_fortune_chat_rooms.status: 10
   */
  inactive: "inactive",
  /** tel_fortune_chat_rooms.status: 20 */
  fixingSchedule: "fixing_schedule",
  /** tel_fortune_chat_rooms.status: 21 */
  fixedSchedule: "fixed_schedule",
  /** tel_fortune_chat_rooms.status: 30 */
  rescheduling: "rescheduling",
  /** chat_rooms.status: 20 */
  activated: "activated",
  /** tel_fortune_chat_rooms.status: 31 */
  ringing: "ringing",
  /** tel_fortune_chat_rooms.status: 32 */
  adminAnswered: "admin_answered",
  /** tel_fortune_chat_rooms.status: 33 */
  adminStoppedRinging: "admin_stopped_ringing",
  /** tel_fortune_chat_rooms.status: 34 */
  userStoppedRinging: "user_stopped_ringing",
  /** tel_fortune_chat_rooms.status: 40 */
  endPhoneCall: "end_phone_call",
  /** tel_fortune_chat_rooms.status: 41 */
  cutOff: "cut_off",
  /** tel_fortune_chat_rooms.status: 42 */
  adminMissCall: "admin_miss_call",
  /** tel_fortune_chat_rooms.status: 43 */
  failedTalking: "failed_talking",
  /** tel_fortune_chat_rooms.status: 44 */
  succeededTalking: "succeeded_talking",
  /**
   * chat_room.status: 30
   * tel_fortune_chat_rooms.status: 50
   */
  closed: "closed",
  /**
   * chat_room.status: 40
   * tel_fortune_chat_rooms.status: 60
   */
  standardCanceled: "standard_canceled",
  /** chat_room.status: 41 */
  firstTimeCanceled: "first_time_canceled",
  /** tel_fortune_chat_rooms.status: 61 */
  afterEndCanceled: "after_end_canceled",
  /**
   * chat_room.status: 42
   * tel_fortune_chat_rooms.status: 62
   */
  exceptionalCanceled: "exceptional_canceled",
  /**
   * chat_room.status: 43
   * tel_fortune_chat_rooms.status: 63
   */
  automaticallyCanceled: "automatically_canceled",
} as const;

export type PurchaseHistoryStatus =
  typeof purchaseHistoryStatus[keyof typeof purchaseHistoryStatus];

export interface PurchaseHistory {
  id: number;
  status: PurchaseHistoryStatus;
  type: MenuTypeV2;
  menuId: number;
  menuTitle: string;
  menuImage: string;
  menuPrice: string;
  fortuneTellerImage: string;
  createdAt: string;
}

export type GetPurchaseHistoryListRes = WithPaginationMetaResponse<{
  purchaseHistories: PurchaseHistory[];
}>;
